var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconVerticalMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0767 15.9231C5.0767 14.776 4.14683 13.8462 2.99977 13.8462C1.85272 13.8462 0.922852 14.776 0.922852 15.9231C0.922852 17.0701 1.85272 18 2.99977 18C4.14683 18 5.0767 17.0701 5.0767 15.9231Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0767 8.99998C5.0767 7.85293 4.14683 6.92306 2.99977 6.92306C1.85272 6.92306 0.922852 7.85293 0.922852 8.99998C0.922852 10.147 1.85272 11.0769 2.99977 11.0769C4.14683 11.0769 5.0767 10.147 5.0767 8.99998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0767 2.07695C5.0767 0.929893 4.14683 2.3365e-05 2.99977 2.3365e-05C1.85272 2.3365e-05 0.922852 0.929893 0.922852 2.07695C0.922852 3.224 1.85272 4.15387 2.99977 4.15387C4.14683 4.15387 5.0767 3.224 5.0767 2.07695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconVerticalMore);
export default __webpack_public_path__ + "static/media/buttonIconVerticalMore.cbf883411919c850b23109fea0d52d89.svg";
export { ForwardRef as ReactComponent };